module.exports = __webpack_public_path__ + "img/img3.d1cc1bf3.png";